import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { tboSyncedCityList } from "../../services/userservice";

const SearchableDropdownCity = ({ onSelect }) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    const loadCities = async () => {
      try {
        const response = await tboSyncedCityList();
        const cities = response?.data?.data || [];
        const mappedOptions = cities.map(city => ({
          value: city?.tbo_city_id,
          label: city?.city_name
        }));
        setOptions(mappedOptions);
      } catch (error) {
        console.error("Failed to load cities:", error);
      }
    };

    loadCities();
  }, []);

  const handleChange = (selected) => {
    setSelectedOption(selected);
    if (onSelect) onSelect(selected);
  };

  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Select a city"
      isClearable
    />
  );
};

export default SearchableDropdownCity;
